import {Icon, type IconName} from '@wandb/components';
import type {ReactNode} from 'react';

import css from './CLILogin.module.css';

export const CLILoginLayout = ({
  icon,
  children,
}: {
  icon: IconName;
  children: ReactNode;
}) => (
  <main className={css.page}>
    <div aria-hidden="true" className={css.badge}>
      <Icon icon={icon} color="teal" size="xl" />
    </div>
    <div className={css.measure}>{children}</div>
  </main>
);

export const CLILoginCard = ({
  heading,
  children,
}: {
  heading: string;
  children?: ReactNode;
}) => (
  <section className={css.card}>
    <h1 className={css.heading}>{heading}</h1>
    {children}
  </section>
);
